import React, { HTMLAttributes, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { logout } from '../redux/slices/kstadiumSlice';
import useOTP, { OTPType, OTPModalType } from '../hooks/mutates/useOTP';
import {
  ModalOTPCheck,
  ModalOTPFailed,
  ModalOTPTimeLimit,
} from '../components/modal/otp';

interface Props extends HTMLAttributes<HTMLElement> {
  type: OTPType;
  OTPModal: OTPModalType | null;
  setOTPModal: React.Dispatch<React.SetStateAction<OTPModalType | null>>;
  onSuccess: (result: { accessToken: string; refreshToken: string }) => void;
  handleCloseModal: VoidFunction;
}

const OTPProvider: React.FC<Props> = ({
  type,
  OTPModal,
  setOTPModal,
  onSuccess,
  handleCloseModal,
  children,
}) => {
  const dispatch = useDispatch();
  const { control, onSubmit, reset } = useOTP(type, setOTPModal, onSuccess);

  const handleChangeOTPCheck = () => setOTPModal(`otp`);

  const handleCloseTimeLimitModal = () => {
    dispatch(logout());
    window.location.replace(`/bridge`);
  };

  useEffect(() => {
    reset();
  }, [OTPModal, reset]);

  return (
    <>
      {children}
      <ModalOTPCheck
        isShow={OTPModal === `otp`}
        onRequestClose={handleCloseModal}
        control={control}
        onClick={onSubmit}
      />
      <ModalOTPFailed
        type={type}
        isShow={OTPModal === `failed`}
        onRequestClose={handleCloseModal}
        onClick={handleChangeOTPCheck}
      />
      <ModalOTPTimeLimit
        type={type}
        isShow={OTPModal === `timeLimit`}
        onRequestClose={handleCloseTimeLimitModal}
      />
    </>
  );
};

export default OTPProvider;
